import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../data/site";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { CtaBlock } from "./About";

export default function Projects() {
  const categories = useMemo(() => ["All", ...Array.from(new Set(PROJECTS.map((p) => p.category)))], []);
  const [active, setActive] = useState("All");

  const filtered = useMemo(
    () => (active === "All" ? PROJECTS : PROJECTS.filter((p) => p.category === active)),
    [active]
  );

  return (
    <>
      <PageHero
        eyebrow="Selected projects"
        title={<>Real systems.<br/><span className="text-[var(--primary)]">Real consequences.</span></>}
        subtitle="A selection of engineering programs UMD has designed, built and sustained — across infrastructure, utilities, defence, manufacturing and beyond."
        image="https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1920&q=80"
      />

      <section className="py-24 md:py-32 container-wide">
        <div className="flex flex-wrap gap-3 mb-12" data-testid="projects-filter-bar">
          {categories.map((c) => (
            <button
              key={c}
              data-testid={`filter-${c.toLowerCase()}`}
              onClick={() => setActive(c)}
              className={`filter-btn ${active === c ? "active" : ""}`}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {filtered.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 4) * 60}>
              <Link to="/contact" data-testid={`project-tile-${p.slug}`} className="proj-card block aspect-[4/3] relative group">
                <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
                <div className="proj-mask absolute inset-0" />
                <div className="absolute top-5 left-5 font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/80 bg-black/30 backdrop-blur-md px-3 py-1.5">{p.category} · {p.year}</div>
                <div className="absolute bottom-6 left-6 right-6 text-white">
                  <h3 className="font-display text-xl md:text-3xl leading-tight tracking-tight">{p.title}</h3>
                  <p className="text-sm text-white/70 mt-3 max-w-md leading-relaxed">{p.summary}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <span className="text-xs font-mono-tech text-white/50 tracking-wider uppercase">{p.location}</span>
                    <ArrowUpRight size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBlock />
    </>
  );
}
